/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {UIRouter} from '@uirouter/core';

import {LayoutCopyModalComponent} from './layout-copy-modal.component';
import {LayoutExampleCopyModalComponent, LayoutExampleCopySelectionResult} from './layout-example-copy-modal.component';
import {AdminResourceCopyConfig} from '../../common/controller/admin-resource-copy-config';
import {AdminResourceRouteContext, readAdminResourceRouteContext} from '../../common/controller/admin-resource-route-context';
import {AngularModalService} from '../../common/modal/angular-modal.service';
import {handleCopyModalResult} from '../../common/util/handle-copy-modal-result';

@Component({
  standalone: false,
  selector: 'adn-layout-context-route-page',
  template: `
    <ng-container *ngIf="context">
      <adn-admin-resource-context-actions
        [model]="context.model"
        [modelComms]="context.modelComms"
        [isNew]="context.isNew"
        [readOnly]="context.readOnly"
        [copyConfig]="copyConfig">
      </adn-admin-resource-context-actions>
      <a *ngIf="!context.isNew && !context.readOnly"
         class="btn btn-default btn-xs"
         style="margin-left: 5px"
         (click)="copyFromLayoutExample()">
        <span class="fa fa-fw fa-copy"></span>Copy from Layout Example
      </a>
    </ng-container>
  `
})
export class LayoutContextRoutePageComponent implements OnInit {
  context: AdminResourceRouteContext;

  readonly copyConfig: AdminResourceCopyConfig = {
    modalComponent: LayoutCopyModalComponent,
    stateUrl: 'app.adm.layouts.layout',
    lcase: 'layout',
    ucase: 'Layout'
  };

  constructor(
    private readonly uiRouter: UIRouter,
    private readonly angularModalService: AngularModalService
  ) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }

  copyFromLayoutExample(): void {
    if (!this.context?.model || !this.context.modelComms) {
      return;
    }

    const modalRef = this.angularModalService.show(LayoutExampleCopyModalComponent, {
      initialState: {model: this.context.model}
    });

    (modalRef.content as LayoutExampleCopyModalComponent).onCopied.subscribe((result: LayoutExampleCopySelectionResult) => {
      handleCopyModalResult(() => {
        const updatedModel = this.context.model;
        if (result.copyName) {
          updatedModel.name = result.layoutExample.name;
        }
        if (result.copyDescription) {
          updatedModel.description = result.layoutExample.description;
        }
        updatedModel.layoutComponents = _.cloneDeep(result.layoutExample.layoutComponents);
        updatedModel.layoutType = result.layoutExample.layoutType;
        updatedModel.renderTemplate = result.layoutExample.renderTemplate;
        this.context.modelComms.modelUpdated(updatedModel);
      });
    });
  }
}
